<div class="forbidden-container">
  <h1>Forbidden</h1>
  <h3>You don't have permission to access this resource</h3>
</div>
